import React from 'react';
import { Comp } from '../components/page-view/types';

type ComViewProps = {
  layoutType: 'FLOW' | 'GRID';
  clientType: 'PC' | 'MOBILE';
  comp: Comp;
  children: React.ReactChildren;
};

const CustomComView = (props: ComViewProps) => {
  const { comp } = props;

  const visible = !comp.pid;

  if (!visible) return null;

  if (props.children) {
    return <>{props.children}</>;
  }
  return null;
};

export default CustomComView;
